import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { GlobalContainer } from "./context/globalContext";
import ReactGA from "react-ga4";
import { HelmetProvider } from "react-helmet-async";
import { initSentry } from "./config/sentry";

initSentry();

// Google Analytics 4 — only initialised when:
//   1. REACT_APP_GA_ID is set in the build env (blank in dev)
//   2. the user has accepted the analytics cookie (cookieAnalytics === 1)
//
// The cookie banner toggles localStorage.cookieAnalytics; the consent change
// triggers a re-render in this RootComponent, which re-runs the effect.
const GA_ID = process.env.REACT_APP_GA_ID;
let gaInitialised = false;
function initialiseAnalytics(): void {
  if (gaInitialised || !GA_ID) return;
  ReactGA.initialize(GA_ID);
  gaInitialised = true;
}

const sendAnalyticsPageView = () => {
  if (!gaInitialised) return;
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
  });
};

const RootComponent = () => {
  const [analytics, setAnalytics] = useState(
    localStorage.getItem("cookieAnalytics")
      ? +localStorage.getItem("cookieAnalytics")!
      : 0,
  );

  useEffect(() => {
    if (analytics) {
      initialiseAnalytics();
      reportWebVitals(sendAnalyticsPageView);
      // Send an initial pageview when consent is granted.
      sendAnalyticsPageView();
    }
  }, [analytics]);

  return (
    <HelmetProvider>
      <GlobalContainer setAnalytics={setAnalytics} />
    </HelmetProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(<RootComponent />);
